import { Box, Button, CircularProgress, TextField } from '@mui/material';
import { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import { GetSignupUserDataResponse, UsersGateApiClient } from '../Api/ApiServerHooks';
import { BrandingGateApiClient } from '../Api/BrandingGateApiClient';
import { useGateApi } from '../Api/useGateApi';
import { useGateMainContext } from '../GateMainContext';
import { useTranslation } from 'react-i18next';

interface UserResetPasswordProps {
}

export default function UserResetPasswordScene(props: UserResetPasswordProps) {
    const { t } = useTranslation();
    const [buttonDisabled, setButtonDisabled] = useState(false);
    const [token, setToken] = useState<string>();
    const [userData, setUserData] = useState<GetSignupUserDataResponse>();
    const [newPass, setNewPass] = useState<string>('');
    const [newPassCheck, setNewPassCheck] = useState<string>('');
    const location = useLocation();
    const navigate = useNavigate();
    const { authorizedApi } = useGateApi(UsersGateApiClient);
    const { unauthorizedApi: brandingApi } = useGateApi(BrandingGateApiClient);
    const { setPreLoginBranding } = useGateMainContext();

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        let tok = queryParams.get('token');
        setToken(tok !== null ? tok : undefined);
    }, [location.search]);

    // Apply the tenant's branding (passed as ?tenant=<slug> in the reset link) so the page
    // matches the branded login experience. Falls back to default branding otherwise.
    useEffect(() => {
        const tenantSlug = new URLSearchParams(location.search).get('tenant');
        if (!tenantSlug) return;
        let active = true;
        brandingApi.getBrandingBySlug(tenantSlug)
            .then((resolved) => { if (active) setPreLoginBranding(resolved); })
            .catch(() => { if (active) setPreLoginBranding(null); });
        return () => { active = false; };
    }, [location.search, brandingApi, setPreLoginBranding]);

    useEffect(() => {
        if (token) {
            authorizedApi?.getResetPasswordUserData(token).then((res) => {
                setUserData(res);
            });
        }
        else setUserData(undefined);
    }, [token, authorizedApi]);

    function changePassword() {
        if (newPass.length !== 0 && newPassCheck.length !== 0 && newPass === newPassCheck && userData && userData.userId && token) {
            setButtonDisabled(true);
            authorizedApi?.setUserPassword(userData.userId, token, newPass).then((d) => {
                setButtonDisabled(false);
                if (d.ok === true)
                    navigate('/?email=' + d.email);
            });
        }
    }

    if (userData)
        return (
            <Box sx={{ width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <Box>
                    <Box>
                        <Box>
                            <Box>
                                <TextField sx={{ margin: '12px', marginLeft: '24px', width: '350px' }} label={t('Users.PasswordNew')}
                                    type={"password"}
                                    size='small'
                                    name='new-pass'
                                    variant='outlined'
                                    value={newPass}
                                    onChange={(e) => { setNewPass(e.currentTarget.value); }} />
                            </Box>
                            <Box>
                                <TextField sx={{ margin: '12px', marginLeft: '24px', width: '350px' }} label={t('Users.PasswordNewAgain')}
                                    type={"password"}
                                    size='small'
                                    name='new-pass-check'
                                    variant='outlined'
                                    value={newPassCheck}
                                    onChange={(e) => { setNewPassCheck(e.currentTarget.value); }} />
                            </Box>
                        </Box>
                        <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center', marginTop: '16px' }}>
                            <Button variant='contained' sx={{ margin: 'auto' }} onClick={changePassword}
                                disabled={newPass.length === 0 || newPassCheck.length === 0 || newPass !== newPassCheck || !userData || !userData.userId || !token || buttonDisabled}
                            >{t('Users.DoChangePassword')}</Button>
                        </Box>
                    </Box>
                </Box>
            </Box>
        )
    else
        return <Box sx={{ width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}><CircularProgress /></Box>
}
